export default __webpack_public_path__ + "ffab39d3487de561be1a081fcfb3806d.png";